import React from "react";

import AddIcon from "@mui/icons-material/Add";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";

// The editor pages can run to many cards, which pushed the old inline "Add
// content" button off the top of the screen. This keeps the action within reach
// wherever the page is scrolled.
//
// ToolbarWithLogo pins a 52px bar to the bottom of the page, but only from the
// `sm` breakpoint up — below that it renders nothing on these routes, so the
// button drops back down to a normal margin.
const TOOLBAR_HEIGHT = 52;
const EDGE_GAP = 16;

export default function FloatingAddContentButton({
    id,
    label = "Add content",
    onClick,
}) {
    return (
        <Tooltip title={label} placement="left">
            <Fab
                id={id}
                color="primary"
                aria-label={label}
                onClick={onClick}
                sx={{
                    position: "fixed",
                    right: { xs: EDGE_GAP, sm: 24 },
                    bottom: {
                        xs: EDGE_GAP,
                        sm: TOOLBAR_HEIGHT + EDGE_GAP,
                    },
                    zIndex: (theme) => theme.zIndex.fab,
                    boxShadow: "0 6px 20px rgba(20, 35, 25, 0.24)",
                    "&:hover": {
                        boxShadow: "0 8px 26px rgba(20, 35, 25, 0.3)",
                    },
                }}
            >
                <AddIcon />
            </Fab>
        </Tooltip>
    );
}
